import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import Home from './page/home/Home';
import About from './page/about/About';
import Skill from './page/skill/Skill';
import Project from './page/project/Project';
import Contact from './page/contact/Contact';
import Gift from './page/gift/Gift';
import './App.css';

function App() {
  useEffect(() => {
    // Tạo hiệu ứng tuyết rơi
    function createSnowflake() {
      const snowflake = document.createElement('div');
      snowflake.classList.add('snowflake');
      snowflake.textContent = '❄';
      snowflake.style.left = Math.random() * 100 + 'vw'; // Vị trí ngang ngẫu nhiên
      snowflake.style.animationDuration = Math.random() * 3 + 5 + 's'; // Thời gian rơi ngẫu nhiên
      snowflake.style.fontSize = Math.random() * 3 + 3 + 'px'; // Kích thước ngẫu nhiên
      document.body.appendChild(snowflake);

      // Xóa tuyết khi hoàn thành
      setTimeout(() => {
        snowflake.remove();
      }, 8000);
    }

    const snowflakeInterval = setInterval(createSnowflake, 200); // Tạo tuyết mỗi 200ms

    return () => {
      // Xóa interval khi component bị unmount
      clearInterval(snowflakeInterval);
    };
  }, []);

  return (
    <Router>
      <div>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/skill" element={<Skill />} />
            <Route path="/project" element={<Project />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gift" element={<Gift />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
